import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HashLink as Link } from 'react-router-hash-link';

const ExhibitionUsers = (props) => {
  const {
    buttonIcon,
    buttonPosition,
    buttonColor,
    title,
  } = props;

  return (
    <div className={`tile__exhibition ${buttonPosition}`} style={{ borderColor: buttonColor }} >
      <div className="tile-holder" style={{ color: buttonColor }}>
        <div className="title" style={{ color: buttonColor }}>
          <div className="icon">
            <FontAwesomeIcon icon={['far', buttonIcon]} />
          </div>
          <span>{title}</span>
        </div>
        {title === 'Hotels' &&
          <div className="companies">
            <Link to="/main/exhibition/101" className="company">
              <FontAwesomeIcon icon={['far', 'check-circle']} className="completed" />
              <img className="company__image" alt="company" src="https://front.travpromobile.com/source/barcelo/icon.png?fit=clamp&" />
              <div className="company__name">Barcelo</div>
            </Link>
          </div>
        }

        {title === 'Tour Operators' &&
          <div className="companies">
            <Link to="/main/exhibition/101" className="company">
              <FontAwesomeIcon icon={['far', 'check-circle']} className="completed" />
              <img className="company__image" alt="company" src="https://front.travpromobile.com/source/globus/icon.png?fit=clamp&" />
              <div className="company__name">Globus</div>
            </Link>

            <Link to="/main/exhibition/101" className="company">
              <FontAwesomeIcon icon={['far', 'check-circle']} className="completed" />
              <img className="company__image" alt="company" src="https://front.travpromobile.com/source/tauck/icon.png?fit=clamp&" />
              <div className="company__name">Tauck</div>
            </Link>

            <Link to="/main/exhibition/101" className="company">
              <FontAwesomeIcon icon={['far', 'check-circle']} className="completed" />
              <img className="company__image" alt="company" src="https://front.travpromobile.com/source/rm/icon.png?fit=clamp&" />
              <div className="company__name">Rocky Mountaineer</div>
            </Link>


          </div>
        }

        {title === 'Sponsors' &&
        <div className="companies">
          <Link to="/main/exhibition/101" className="company">
            <FontAwesomeIcon icon={['far', 'check-circle']} className="completed" />
            <img className="company__image" alt="company" src="https://front.travpromobile.com/source/tourism-cares/icon.png?fit=clamp&" />
            <div className="company__name">Tourism Cares</div>
          </Link>

          <Link to="/main/exhibition/101" className="company">
            <FontAwesomeIcon icon={['far', 'check-circle']} className="completed" />
            <img className="company__image" alt="company" src="https://front.travpromobile.com/source/ta-connect/icon.png?fit=clamp&" />
            <div className="company__name">TA Connect</div>
          </Link>

          <Link to="/main/exhibition/101" className="company">
            <FontAwesomeIcon icon={['far', 'check-circle']} className="completed" />
            <img className="company__image" alt="company" src="https://travpromobile.com/images/logo-dark@2x.png" />
            <div className="company__name">TravPRO Mobile</div>
          </Link>


        </div>
        }

        {title === 'Attractions' &&
          <div className="companies">
            <Link to="/main/exhibition/101" className="company">
              <FontAwesomeIcon icon={['far', 'check-circle']} className="completed" />
              <img className="company__image" alt="company" src="https://front.travpromobile.com/source/universal/icon.png?fit=clamp&" />
              <div className="company__name">Universal Studios</div>
            </Link>

            <Link to="/main/exhibition/101" className="company">
              <FontAwesomeIcon icon={['far', 'check-circle']} className="completed" />
              <img className="company__image" alt="company" src="https://front.travpromobile.com/source/simon-shopping/icon.png?fit=clamp&" />
              <div className="company__name">Simon Shopping</div>
            </Link>
          </div>
        }

        { title === 'Domestic Destinations' &&
        <div className="companies">

          <Link to="/main/exhibition/101" className="company">
            <FontAwesomeIcon icon={['far', 'check-circle']} className="completed" />
            <img className="company__image" alt="company" src="https://front.travpromobile.com/source/los-angeles/icon.png?fit=clamp&" />
            <div className="company__name">Los Angeles</div>
          </Link>

          <Link to="/main/exhibition/101" className="company">
            <FontAwesomeIcon icon={['far', 'check-circle']} className="completed" />
            <img className="company__image" alt="company" src="https://front.travpromobile.com/source/florida/icon.png?fit=clamp&" />
            <div className="company__name">Florida</div>
          </Link>

          <Link to="/main/exhibition/101" className="company">
            <FontAwesomeIcon icon={['far', 'check-circle']} className="completed" />
            <img className="company__image" alt="company" src="https://front.travpromobile.com/source/anaheim/icon.png?fit=clamp&" />
            <div className="company__name">Anaheim</div>
          </Link>

          <Link to="/main/exhibition/101" className="company">
            <FontAwesomeIcon icon={['far', 'check-circle']} className="completed" />
            <img className="company__image" alt="company" src="https://travpromobileimages.imgix.net/apptool/app/129/images/Icon-180.png?fit=clamp&" />
            <div className="company__name">Houston</div>
          </Link>

          <Link to="/main/exhibition/101" className="company">
            <FontAwesomeIcon icon={['far', 'check-circle']} className="completed" />
            <img className="company__image" alt="company" src="https://front.travpromobile.com/source/dfw/icon.png?fit=clamp&" />
            <div className="company__name">DFW</div>
          </Link>

          <Link to="/main/exhibition/101" className="company">
            <FontAwesomeIcon icon={['far', 'check-circle']} className="completed" />
            <img className="company__image" alt="company" src="https://front.travpromobile.com/source/colorado/icon.png?fit=clamp&" />
            <div className="company__name">Colorado</div>
          </Link>
        </div>
        }

      </div>
    </div>
  );
};

ExhibitionUsers.propTypes = {
  buttonIcon: PropTypes.string,
  buttonPosition: PropTypes.string,
  buttonColor: PropTypes.string,
  title: PropTypes.string,
};

ExhibitionUsers.defaultProps = {
  buttonIcon: '',
  buttonPosition: '',
  buttonColor: '',
  title: '',
};

export default ExhibitionUsers;
